<template>
  <article
    class="product"
    :class="[
      'product--theme-' + theme,
      {
        'product--new': isNew,
        'product--disabled': isDisabled,
      }
    ]"
  >
    <div
      class="product__pics"
    >
      <div
        class="product__pic product__pic--revers"
        :class="product.fileR"
      />
      <div
        class="product__pic product__pic--face"
        :class="product.file"
      />
    </div>

    <div class="product__footer product__footer--mobile">
      <ButtonDefault
        class="product__cta"
        :pointer-absolute="true"
        :to="(!isDisabled ? [$route.path, product.path] : []) | joinPath"
        :label="isDisabled ? product.available : product.mobileTitle"
        :arrow="buttonProps.arrow"
        :negative="isDisabled"
        :border="isDisabled"
        :theme="theme"
      />
    </div>

    <div class="product__footer product__footer--desktop">
      <p
        class="product__name"
        v-html="product.title"
      />

      <div
        class="product__label"
        :class="{ 'product__label--underline': isNew }"
      >
        <p>{{ isNew ? $store.state.config.common.new : buttonProps.label }}</p>
      </div>

      <ButtonDefault
        class="product__cta"
        :pointer-absolute="true"
        :to="(!isDisabled ? [$route.path, product.path] : []) | joinPath"
        :label="buttonProps.label"
        :arrow="buttonProps.arrow"
        :negative="isDisabled"
        :border="isDisabled"
        :theme="theme"
      />
    </div>
  </article>
</template>

<script>
import ButtonDefault from '@/components/buttons/ButtonDefault.vue';

export default {
  components: { ButtonDefault },

  props: {
    product: { type: Object, required: true },
    theme: { type: String, default: null },
  },

  computed: {
    isNew() {
      return this.$props.product.new && this.$props.product.new === true;
    },

    isDisabled() {
      return this.$props.product.available && this.$props.product.available !== true;
    },

    buttonProps() {
      const props = {
        label: this.$store.state.config.common.discoverShortButton,
      };

      if (this.isNew) {
        props.arrow = 'top-right';
      } else if (this.isDisabled) {
        props.label = this.$props.product.available;
        props.disabled = true;
      } else {
        props.arrow = 'top-right';
      }

      return props;
    },
  },
};
</script>

<style lang="stylus" scoped>
.product {
  position: relative;
  cursor: pointer;
  overflow: hidden;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
}

.product__pics {
  height: 379px;
  margin-bottom: 56px;

  .product--disabled & {
    opacity: 0.2;
  }

  +mobile(){
    height: 230px;
    margin-bottom: 36px;
  }
}

.product__pic {
  transition: transform 0.5s $ease-in-out-cubic
  margin: 0 auto;
  max-width: 220px;

  +pointer-device() {
    .product:hover & {
      transition: transform 0.5s $ease-in-out-cubic 0.25s
    }
  }

  &--revers {
    transform: translate3d(0, 20%, 0)
    +pointer-device() {
      .product:hover & {
        transform: translate3d(0, 5%, 0)
      }
    }
  }

  &--face {
    transform: translate3d(0, -20%, 0)
    +pointer-device() {
      .product:hover & {
        transform: translate3d(0, -5%, 0)
      }
    }
  }

  &:before {
    display: none;
  }
}

.product__footer {
  &--mobile {
    +desktop() {
      display: none;
    }
  }

  &--desktop {
    display: none;
    +desktop() {
      display: block;
    }
  }
}

.product__name {
  @extend $typo-collection-name;
  margin: 15px 0;
  color: $cl-green;
  .product--theme-green & { color: $cl-green; }
  .product--theme-purple & { color: $cl-purple; }
  .product--theme-orange & { color: $cl-orange; }
}

.product__cta {
  display: inline-block;
  text-align: center;

  .product--disabled & {
    cursor: default;
  }

  .product__footer--desktop & {
    opacity: 0;
  }

  .product:hover & {
    opacity: 1;
    transition: opacity 0.25s ease-in 0.5s;
  }
}

.product__label {
  @extend $typo-collection-label;
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  margin: 0 auto;

  color: $cl-green;
  opacity: 1;
  transition: opacity 0.25s ease-in 0.25s;

  .product--theme-green & { color: $cl-green; }
  .product--theme-purple & { color: $cl-purple; }
  .product--theme-orange & { color: $cl-orange; }

  .product:hover & {
    opacity: 0;
    transition: opacity 0.25s ease-in 0;
  }

  p {
    margin: 0;
    display: inline-block;
    padding-bottom: 2px;
  }

  &--underline {
    p {
      border-bottom: 2px solid currentColor;
    }
  }
}
</style>
